import React from 'react';
import { Heading, Icon } from 'ui/components';
import styles from '../Profile.module.scss';

export interface ProfileItemProps {
	title: string;
	icon: React.ReactNode;
	children: React.ReactNode;
}

export const ProfileItem: React.FC<ProfileItemProps> = ({ title, icon, children }) => {
	return (
		<article className={styles.Profile_categories}>
			<Heading headingLevel="h2" className={styles.Profile_subHeading}>
				<Icon className={styles.Profile_iconCategory}>{icon}</Icon>
				<span>{title}</span>
			</Heading>
			<section className={styles.Profile_columnsWrapper}>{children}</section>
		</article>
	);
};
